import React, { useRef, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import schorLogo1 from "assets/images/schor-logo.png"
import schorFrenchLogo from "assets/images/french-logo.png"
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { loginParticipantUser } from 'store/actions';
import toastr from 'toastr';
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import PropTypes from "prop-types";
import LanguageDropdownWithoutLogin from 'components/CommonForBoth/TopbarDropdown/LanguageDropdownWithoutLogin';


const sitekey = process.env.REACT_APP_ENV == "development" ? process.env.REACT_APP_CAPTCHA_KEY_DEV : process.env.REACT_APP_CAPTCHA_KEY_PROD
console.log("RATER LOGIN SITEKEY:-", sitekey)


const RaterLogin = props => {
    const recaptchaRef = useRef(null);
    const [isNewUser, setIsNewUser] = useState(true);
    const [capVal, SetCapVal] = useState(null);
    const [language, setLanguage] = useState("en");
    const [key, setKey] = useState(Date.now());
    const navigate = useNavigate()

    //meta title
    document.title = "Login | Institute on Governance - Admin & Dashboard";

    const dispatch = useDispatch();
    const { loading } = useSelector((s) => s.ParticipantLogin)

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: isNewUser ?
            {
                authentication_code: ''
            }
            :
            {
                username: '',
                password: ''

            },
        validationSchema: isNewUser ?
            Yup.object({
                authentication_code: Yup.string().required(props.t("Please Enter ID")),

            })
            :
            Yup.object({
                username: Yup.string().required(props.t("Please Enter Your Username")),
                password: Yup.string().required(props.t("Please Enter Your Password")),

            }),
        onSubmit: (values) => {
            if (capVal) {
                values = {
                    ...values,
                    recaptchaToken: capVal || null
                }
            }
            dispatch(loginParticipantUser(values, "rater", (res) => {
                if (res.status === "success") {
                    localStorage.setItem("number", 60)
                    toastr.success(res?.message)
                    window.location.href = '/save-servey'

                } else {
                    toastr.error(res?.message)
                }
            }))
        }
    });

    const { error } = useSelector(state => ({
        error: state.ParticipantLogin.error,
    }));
    const onChangeCaptcha = (value) => {
        SetCapVal(value)
    }

    const handleSelectedLanguage = (lang) => {

        if (lang === "en") {
            setLanguage("en");
            setKey(Date.now());
            // console.log("Selected language: English");
        }

        if (lang === "es") {
            setLanguage("es");
            setKey(Date.now());
            // console.log("Selected language: Spanish");
        }

        if (lang === "fr") {
            setLanguage("fr");
            setKey(Date.now());
            // console.log("Selected language: French");
        }

        if (lang === "iu") {
            setLanguage("en");
            setKey(Date.now());
            // console.log("Selected language: Inuktitut");
        }

        if (lang === "ar") {
            setLanguage("ar");
            setKey(Date.now());
            // console.log("Selected language: Inuktitut");
        }

        if (lang === "ku") {
            setLanguage("en");
            setKey(Date.now());
            // console.log("Selected language: Inuktitut");
        }

        if (lang === "de") {
            setLanguage("de");
            setKey(Date.now());
            // console.log("Selected language: Inuktitut");
        }
    }

    useEffect(() => {


        if (!localStorage.getItem("i18nextLng") &&
            !localStorage.getItem("language_id") &&
            !localStorage.getItem("I18N_LANGUAGE")) {


            setTimeout(() => {
                localStorage.setItem("i18nextLng", 'EN');
                localStorage.setItem("language_id", '1');
                localStorage.setItem("I18N_LANGUAGE", 'EN');
                i18n.changeLanguage('EN');
            }, 1);
        }

        // setTimeout(() => {
        //     localStorage.setItem("i18nextLng", 'EN');
        //     localStorage.setItem("language_id", '1');
        //     localStorage.setItem("I18N_LANGUAGE", 'EN');
        //     i18n.changeLanguage('EN');
        // }, 1);


        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
        }
    }, [language]);
    return (
        <>
            <div className="account-pages rates-form-admin my-5 pt-sm-5">

                <Container>
                    <div className="main-form-wrapper" style={{ "border": "1px solid #ccc", "padding": "40px 30px 30px", "borderRadius": "20px", 'maxWidth': "800px", "margin": "auto", "background": " #fff" }}>
                        {
                            isNewUser ?
                                <Row className="justify-content-center">
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex justify-content-end">
                                            <LanguageDropdownWithoutLogin selectedLanguage={handleSelectedLanguage} />
                                        </div>
                                        <div style={{ marginTop: '20px', marginLeft: '15px' }}>
                                            <Link to="/" className="text-dark">
                                                <i className="bx bx-home h2" />
                                            </Link>
                                        </div>
                                    </div>
                                    <Col md={10} lg={10} xl={10}>
                                        <Card className="overflow-hidden">
                                            <div className="bg-primary logo-authen">
                                                <Row className="align-items-end justify-content-center">
                                                    <Col className="col-12 align-self-end">
                                                        <div>
                                                            <div className="avatar-md profile-user-wid mb-4 d-flex justify-content-center">
                                                                <span className="avatar-title rounded-circle bg-light">
                                                                    <Link to="/" className="logo-light-element d-block">
                                                                        <img
                                                                            src={language == "fr" ? schorFrenchLogo : schorLogo1}
                                                                            alt=""
                                                                            className="rounded-circle"
                                                                            height="34"
                                                                        />
                                                                    </Link>

                                                                </span>
                                                            </div>
                                                        </div>
                                                        {/* <div className="avatar-md profile-user-wid mb-4">
                                                    <span className="avatar-title w-100 rounded-circle bg-light">
                                                        <img
                                                            src={schorLogo1}
                                                            alt=""
                                                            className="rounded-circle"
                                                            height="34"
                                                        />
                                                    </span>
                                                </div> */}
                                                    </Col>
                                                </Row>
                                            </div>

                                            <CardBody className='d-block mt-0'>
                                                <h3 className="text-center text-black mb-4">{props.t("Please enter Your Authentication Code")}
                                                </h3>
                                                <Form
                                                    className="form-horizontal"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}
                                                >
                                                    {error ? <Alert color="danger">{error}</Alert> : null}

                                                    <div className="mb-3">
                                                        <Label className="form-label m-0">{props.t("Authentication ID")}:</Label>
                                                        <Input
                                                            name="authentication_code"
                                                            className="form-control"
                                                            placeholder={props.t("Enter Authentication Code")}
                                                            type="text"
                                                            // onChange={validation.handleChange}
                                                            onChange={(e) => {
                                                                const val = e.target.value.replace(/\s+/g, ""); // remove all spaces
                                                                validation.setFieldValue("authentication_code", val);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.authentication_code || ""}
                                                            invalid={
                                                                validation.touched.authentication_code && validation.errors.authentication_code ? true : false
                                                            }
                                                        />
                                                        {
                                                            validation.touched.authentication_code && validation.errors.authentication_code ? (
                                                                <FormFeedback type="invalid">{validation.errors.authentication_code}</FormFeedback>
                                                            ) : null
                                                        }
                                                    </div>


                                                    <div className="mb-3">
                                                        {/* <Label className="form-label m-0">{props.t("Verification")}:</Label> */}
                                                        <div style={{ height: '70px' }}>
                                                            <ReCAPTCHA
                                                                ref={recaptchaRef}
                                                                hl={language}
                                                                key={key}
                                                                sitekey={sitekey}
                                                                onChange={(val) => onChangeCaptcha(val)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="btn-login-admin authen-btn mt-3 gap-3 d-flex align-items-center">
                                                        {
                                                            loading ?
                                                                <div className='batches-add-modal-btn'>
                                                                    <button
                                                                        className="btn btn-primary btn-block me-0"
                                                                        disabled
                                                                        style={{ width: '145px' }}
                                                                    >
                                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                        {props.t("Authenticate")}
                                                                    </button>
                                                                </div>
                                                                :
                                                                <div className='batches-add-modal-btn'>
                                                                    <button
                                                                        className="btn btn-primary btn-block me-0"
                                                                        type="submit"
                                                                        style={{ width: '120px' }}
                                                                    >
                                                                        {props.t("Authenticate")}

                                                                    </button>
                                                                </div>
                                                        }
                                                        <Link to="#" onClick={() => setIsNewUser(!isNewUser)}>
                                                            {props.t("To continue a survey you already started click here")}
                                                        </Link>
                                                    </div>

                                                </Form>

                                            </CardBody>
                                        </Card>

                                    </Col>
                                </Row>
                                :
                                <Row className="justify-content-center">
                                    <div className="d-flex justify-content-end">
                                        <div className="d-flex justify-content-end">
                                            <LanguageDropdownWithoutLogin selectedLanguage={handleSelectedLanguage} />
                                        </div>
                                        <div style={{ marginTop: '20px', marginLeft: '15px' }}>
                                            <Link to="/" className="text-dark">
                                                <i className="bx bx-home h2" />
                                            </Link>
                                        </div>
                                    </div>
                                    <Card className="overflow-hidden">
                                        <div>
                                            <div className="avatar-md profile-user-wid mb-4 d-flex justify-content-center">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <Link to="/" className="logo-light-element d-block">
                                                        <img
                                                            src={language == "fr" ? schorFrenchLogo : schorLogo1}
                                                            alt=""
                                                            className="rounded-circle"
                                                            height="34"
                                                        />
                                                    </Link>

                                                </span>
                                            </div>
                                        </div>
                                        <Row className="align-items-end text-center justify-content-center">
                                            <Col xs={9}>
                                                <div className="text-primary p-4 pb-0 heading-form">
                                                    <p className="text-black">{props.t("Sign in to continue")}.</p>
                                                </div>
                                            </Col>
                                        </Row>
                                        <CardBody className="pt-0 pb-2">
                                            <div className="p-2">
                                                <Form
                                                    className="form-horizontal"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}
                                                >
                                                    {error ? <Alert color="danger">{error}</Alert> : null}

                                                    <div className="mb-3">
                                                        <Label className="form-label m-0">{props.t("Username")}:</Label>
                                                        <Input
                                                            name="username"
                                                            className="form-control"
                                                            placeholder={props.t("Enter username")}
                                                            type="text"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.username || ""}
                                                            invalid={
                                                                validation.touched.username && validation.errors.username ? true : false
                                                            }
                                                        />
                                                        {validation.touched.username && validation.errors.username ? (
                                                            <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                                        ) : null}
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label className="form-label m-0">{props.t("Password")}:</Label>
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type="password"
                                                            placeholder={props.t("Enter Password")}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                    </div>

                                                    <div className="mb-3">
                                                        {/* <Label className="form-label m-0">{props.t("Verification")}:</Label> */}
                                                        <div style={{ height: '70px' }}>
                                                            <ReCAPTCHA
                                                                ref={recaptchaRef}
                                                                hl={language}
                                                                key={key}
                                                                sitekey={sitekey}
                                                                onChange={(val) => onChangeCaptcha(val)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="btn-login-admin mt-3 d-grid batches-add-modal-btn">

                                                        {
                                                            loading ?
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-dark "
                                                                    disabled
                                                                >
                                                                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                </button>
                                                                :
                                                                <button
                                                                    // disabled={!capVal}
                                                                    className="btn btn-primary btn-block green-btn"
                                                                    type="submit"
                                                                >
                                                                    {props.t("Log In")}
                                                                </button>
                                                        }
                                                    </div>
                                                    <Link to="#" onClick={() => setIsNewUser(!isNewUser)}> {props.t("New User ? Login here")}</Link>

                                                </Form>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Row>
                        }
                        <div className="mt-5 text-center">
                            <p className="m-0 text-center">
                                © {new Date().getFullYear()} Institute on Governance. {props.t("Crafted with")}{" "}
                                <i className="mdi mdi-heart text-danger" /> {props.t("by Suffescom")}
                            </p>
                        </div>
                    </div>
                </Container>
            </div>

        </>
    )
}

RaterLogin.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(RaterLogin);
